import "@/Assets/sass/main.scss";

import { createApp } from "vue";
import { createPinia } from "pinia";
import { IonicVue } from "@ionic/vue";
import VueDatePicker from "@vuepic/vue-datepicker";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import VueTouch from "vue3-touch-hammer";

import i18n from "@/Plugins/i18n";

/* Vue datepicker styles */
import "@vuepic/vue-datepicker/dist/main.css";

import App from "./App.vue";

import AppRouter from "./Router";

const app = createApp(App);

app.use(createPinia());
app.use(IonicVue);
app.use(AppRouter.getInstance());
app.use(i18n);
app.use(VueTouch, { name: "v-touch" });

app.component("VueDatePicker", VueDatePicker);

AppRouter.isReady().then(async () => {
  app.mount("#app");
});
